import { isIOS } from "react-device-detect";
import { FloatType, HalfFloatType } from "three";

const config = {
  floatType: isIOS ? HalfFloatType : FloatType
};

export default config;
